import axios from 'axios';

import AuthService from '../../shared/services/AuthService';
import Config from '../../shared/config';

class CertService {
  private async getCert(url: string): Promise<Blob> {
    const accessToken = AuthService.getAccessToken();

    const { data } = await axios({
      method: 'GET',
      headers: {
        authorization: `Bearer ${accessToken}`
      },
      responseType: 'blob', // important
      url
    });

    return new Blob([data], { type: 'application/pdf' });
  }
  /**
   * Pathway
   */
  public async getCertFile(username: string, lessonkey: string) {
    const url = `${Config.REPORT_DS}/api/certificates/users/${username}/lessons/${lessonkey}`;
    return this.getCert(url);
  }

  /**
   * Module certificate on a course.
   */
  public async getModuleCertificate(
    userkey: number,
    modulekey: number
  ): Promise<Blob> {
    const url = `${Config.ASSET_DS}/api/certificate/user/${userkey}/module/${modulekey}`;
    return this.getCert(url);
  }

  /**
   * Course
   */
  public async getCourseCertificate(
    userkey: number,
    coursekey: number
  ): Promise<Blob> {
    const url = `${Config.ASSET_DS}/api/certificate/user/${userkey}/course/${coursekey}`;
    return this.getCert(url);
  }

  /**
   * Course Certificate Preview
   */
  public async getCourseCertificatePreview(media: string): Promise<Blob> {
    const encodedMedia = encodeURIComponent(media);
    const url = `${Config.ASSET_DS}/api/certificate/preview/${encodedMedia}`;
    return this.getCert(url);
  }
}

export default new CertService();
